import { Typography, Paper, Box } from '@mui/material'
import { useAuthStore } from '../stores/auth.store'

export function HomePage() {
  const { user } = useAuthStore()

  return (
    <Box>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
        Welcome, {user?.display_name || user?.username}
      </Typography>
      <Paper sx={{ p: 3, mt: 2 }}>
        <Typography variant="body1" color="text.secondary">
          Select an object from the sidebar to get started.
        </Typography>
      </Paper>
    </Box>
  )
}
